import { AppBar, Toolbar, IconButton, Fab, Avatar } from '@material-ui/core'
import AccountCircle from '@material-ui/icons/AccountCircle'
import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import HomeIcon from '@material-ui/icons/Home'
import AddIcon from '@material-ui/icons/Add'
import { FirestoreContext } from '../../providers/firestore-provider'

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
  appBar: {
    top: 'auto',
    bottom: 0,
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}))

interface IMobileNavigationProps {
  onClickMenuItem: (pageURL: string) => void
  onClickPlusItem: () => void
}

export const MobileNavitagion = ({
  onClickMenuItem,
  onClickPlusItem,
}: IMobileNavigationProps) => {
  const classes = useStyles()
  const { currentUser } = useContext(FirestoreContext)
  return (
    <AppBar position="fixed" color="primary" className={classes.appBar}>
      <Toolbar>
        <IconButton color="inherit" onClick={() => onClickMenuItem('/home')}>
          <HomeIcon />
        </IconButton>
        <Fab
          color="secondary"
          aria-label="add"
          className={classes.fabButton}
          onClick={onClickPlusItem}
        >
          <AddIcon />
        </Fab>
        <div className={classes.grow} />
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => onClickMenuItem('/profile')}
        >
          {currentUser?.photoURL ? (
            <Avatar
              alt={currentUser?.displayName || ''}
              src={currentUser?.photoURL}
              className={classes.small}
            />
          ) : (
            <AccountCircle />
          )}
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}
